import { bunja } from 'bunja';
import { atom } from 'jotai';

import { tpslModalBunja } from '../state';
import { instrumentBunja, parentPositionBunja } from '../state/base';
import { sortByOrderTimeDesc } from './sort';

export const tpslManageModalBunja = bunja(() => {
  const { tpslOrderSideAtom, symbol, tpslType, positionQtyAtom, positionType, tpslTabAtom, positionSlot } =
    bunja.use(tpslModalBunja);
  const { marginType, liqPriceAtom } = bunja.use(parentPositionBunja);
  const { pricePrecisionAtom, tradeQtyPrecisionAtom, positionUnitAtom, quoteCurrencyAtom } = bunja.use(instrumentBunja);
  const {
    sideAtom,
    leverageAtom,
    entryPriceAtom,
    markPriceAtom,
    entireTpOrdersAtom,
    entireSlOrdersAtom,
    partialTpOrdersAtom,
    partialSlOrdersAtom,
  } = bunja.use(parentPositionBunja);

  const tpslOrdersAtom = atom((get) => {
    const orders = (() => {
      const tpslTab = get(tpslTabAtom);
      switch (tpslTab) {
        case 'entire': {
          const tpOrders = get(entireTpOrdersAtom);
          const slOrders = get(entireSlOrdersAtom);
          return tpslType === 'tp' ? tpOrders : slOrders;
        }
        case 'partial': {
          const tpOrders = get(partialTpOrdersAtom);
          const slOrders = get(partialSlOrdersAtom);
          return tpslType === 'tp' ? tpOrders : slOrders;
        }
        default:
          return [];
      }
    })();
    return sortByOrderTimeDesc(orders);
  });

  return {
    sideAtom,
    leverageAtom,
    marginType,
    positionType,
    tpslOrdersAtom,
    liqPriceAtom,
    entryPriceAtom,
    markPriceAtom,
    pricePrecisionAtom,
    tradeQtyPrecisionAtom,
    positionUnitAtom,
    quoteCurrencyAtom,
    positionQtyAtom,
    tpslOrderSideAtom,
    positionSlot,
    symbol,
    tpslType,
    tpslTabAtom,
  };
});
tpslManageModalBunja.debugLabel = 'tpslManageModalBunja';
